import type { SVGProps } from "react";

const base = {
  width: 22,
  height: 22,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const Icon = {
  Hammer: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M14 4l6 6-2 2-3-3-7 7-3-3 7-7-3-3 2-2z" />
      <path d="M5 17l-3 3" />
    </svg>
  ),
  Hardhat: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M3 18h18M5 18a7 7 0 0 1 14 0" />
      <path d="M10 11V7h4v4" />
    </svg>
  ),
  Wrench: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.7-.3-.3-2.7 2.5-2.5z" />
    </svg>
  ),
  Bolt: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
    </svg>
  ),
  Saw: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M3 12l3-3 2 2 3-3 2 2 3-3 2 2 3-3" />
      <path d="M3 12v3a3 3 0 0 0 3 3h12l3-3" />
    </svg>
  ),
  House: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z" />
    </svg>
  ),
  Tree: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M12 3l5 7h-3l4 6H6l4-6H7l5-7z" />
      <path d="M12 16v5" />
    </svg>
  ),
  Compass: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9l-2 6-4 1 1-4 5-3z" />
    </svg>
  ),
  Brush: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M4 20c0-3 3-3 3-6V8a4 4 0 0 1 4-4h7v8h-3v8a4 4 0 0 1-4 4z" />
    </svg>
  ),
  Wind: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M3 9h11a3 3 0 1 0-3-3M3 15h15a3 3 0 1 1-3 3" />
    </svg>
  ),
  Shield: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z" />
    </svg>
  ),
  Toolbox: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <rect x="3" y="8" width="18" height="12" rx="2" />
      <path d="M9 8V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M3 13h18" />
    </svg>
  ),
  Sparkle: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M12 3v6M12 15v6M3 12h6M15 12h6" />
    </svg>
  ),
  Plank: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <rect x="3" y="9" width="18" height="6" rx="1" />
      <path d="M7 9v6M11 9v6M15 9v6" />
    </svg>
  ),
  Spanner: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M9 6a4 4 0 1 1 6 6l6 6-2 2-6-6a4 4 0 0 1-6-6z" />
    </svg>
  ),
  Buildings: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <rect x="3" y="9" width="7" height="12" />
      <rect x="14" y="3" width="7" height="18" />
      <path d="M16 7h3M16 11h3M16 15h3M5 13h3M5 17h3" />
    </svg>
  ),
  Crane: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M4 21V5l16-2v4M4 9h16M8 9v12M12 9v6h6" />
    </svg>
  ),
  Drill: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M3 8h10v6H3zM13 9l4-2v8l-4-2M17 21h-3" />
    </svg>
  ),
  Check: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M5 12l5 5L20 7" />
    </svg>
  ),
  Phone: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M5 4h4l2 5-3 2a12 12 0 0 0 6 6l2-3 5 2v4a2 2 0 0 1-2 2A17 17 0 0 1 3 6a2 2 0 0 1 2-2z" />
    </svg>
  ),
  Mail: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  ),
  Pin: (p: SVGProps<SVGSVGElement>) => (
    <svg {...base} {...p}>
      <path d="M12 21s7-7 7-12a7 7 0 1 0-14 0c0 5 7 12 7 12z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  ),
};

export const industryIconMap: Record<string, keyof typeof Icon> = {
  "main-contractors": "Buildings",
  "building-firms": "Crane",
  "construction-recruitment": "Hardhat",
  "product-manufacturers": "Toolbox",
  tradesmen: "Spanner",
  plumbers: "Wrench",
  electricians: "Bolt",
  carpenters: "Saw",
  roofers: "House",
  builders: "Hammer",
  landscapers: "Tree",
  architects: "Compass",
  "painters-decorators": "Brush",
  hvac: "Wind",
  "property-maintenance": "Shield",
  handyman: "Toolbox",
  "home-improvement": "Sparkle",
  flooring: "Plank",
};

export const serviceIconMap: Record<string, keyof typeof Icon> = {
  "construction-website-design": "Buildings",
  "seo-for-construction-companies": "Sparkle",
  "construction-lead-generation": "Bolt",
  "hosting-care": "Shield",
};
